/**
 * Londorelle – cart drawer urgency timer.
 * Loaded once as a static module (unlike inline <script> tags, which the
 * Section Rendering API injects via innerHTML and browsers never execute).
 * A MutationObserver watches for [data-lr-urgency-timer] so the countdown
 * keeps working no matter how the drawer content gets swapped in.
 */
const STORAGE_KEY = 'lrCartUrgencyEnd';
const DEFAULT_DURATION = 900;

function bind(el) {
  if (el.dataset.lrUrgencyBound) return;
  el.dataset.lrUrgencyBound = 'true';

  const duration = parseInt(el.getAttribute('data-lr-duration'), 10) || DEFAULT_DURATION;
  const valueEl = el.querySelector('[data-lr-urgency-value]');

  let end = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
  if (!end || Number.isNaN(end)) {
    end = Date.now() + duration * 1000;
    sessionStorage.setItem(STORAGE_KEY, String(end));
  }

  function tick() {
    let remaining = Math.round((end - Date.now()) / 1000);
    if (remaining <= 0) {
      end = Date.now() + duration * 1000;
      sessionStorage.setItem(STORAGE_KEY, String(end));
      remaining = duration;
    }
    const m = Math.floor(remaining / 60);
    const s = remaining % 60;
    if (valueEl) {
      valueEl.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
  }

  tick();
  setInterval(tick, 1000);
}

function scan(root) {
  root.querySelectorAll('[data-lr-urgency-timer]').forEach(bind);
}

scan(document);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.('[data-lr-urgency-timer]')) bind(node);
      node.querySelectorAll?.('[data-lr-urgency-timer]').forEach(bind);
    });
  }
}).observe(document.body, { childList: true, subtree: true });
